exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".download-btn[data-v-71b4b898] {\n  color: #2b93ff !important;\n  margin-top: 5px;\n  display: block;\n  font-size: 12px;\n  cursor: pointer;\n}\n[data-v-71b4b898] .error-body div {\n  margin: 0;\n  margin-top: 20px;\n  padding: 10px;\n}\n.customer-dashboard[data-v-71b4b898]  .md-card {\n  margin-bottom: 0;\n}\n.green-icon[data-v-71b4b898] {\n  color: #0bda8e !important;\n  margin-right: 5px;\n}\n.normal-link[data-v-71b4b898] {\n  color: rgba(0, 0, 0, 0.87) !important;\n}\n.normal-link[data-v-71b4b898]:hover {\n  color: #2b93ff !important;\n}\n", ""]);

// exports
